import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { LogoIcon } from "../LogoWithText";

const BrandBanner = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} data-testid="brand-banner" className="relative py-20 overflow-hidden">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#02040a] via-[#0b1a3a] to-[#02040a]" />
      
      {/* Scrolling watermark background */}
      <div className="absolute inset-0 overflow-hidden opacity-[0.04] select-none pointer-events-none">
        <motion.div
          animate={{ x: [0, -1200] }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          className="whitespace-nowrap text-[120px] font-black text-white tracking-wider"
        >
          GLOBAL METAFORA APP &middot; GLOBAL METAFORA APP &middot; GLOBAL METAFORA APP &middot; GLOBAL METAFORA APP &middot; GLOBAL METAFORA APP &middot;
        </motion.div>
        <motion.div
          animate={{ x: [-1200, 0] }}
          transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
          className="whitespace-nowrap text-[120px] font-black text-white tracking-wider mt-4"
        >
          GLOBAL METAFORA APP &middot; GLOBAL METAFORA APP &middot; GLOBAL METAFORA APP &middot; GLOBAL METAFORA APP &middot; GLOBAL METAFORA APP &middot;
        </motion.div>
      </div>

      {/* Glow effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[200px] bg-[#3b82f6]/10 blur-[100px] rounded-full" />

      {/* Main content */}
      <div className="relative z-10 section-container text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8, type: "spring" }}
          className="flex flex-col items-center gap-6"
        >
          {/* Logo */}
          <motion.div
            animate={{ rotateY: [0, 360] }}
            transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
          >
            <LogoIcon size={64} />
          </motion.div>

          {/* Brand name large */}
          <motion.h2
            className="text-4xl sm:text-5xl lg:text-7xl font-black tracking-tight"
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <span className="text-white">GLOBAL </span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#3b82f6] via-[#06b6d4] to-[#3b82f6]">METAFORA</span>
            <span className="text-white"> APP</span>
          </motion.h2>

          {/* Tagline */}
          <motion.p
            className="text-[#94a3b8] text-base sm:text-lg max-w-lg"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            Tecnologia que transforma empresas
          </motion.p>

          {/* Animated line */}
          <motion.div
            className="h-[2px] bg-gradient-to-r from-transparent via-[#3b82f6] to-transparent"
            initial={{ width: 0 }}
            animate={isInView ? { width: "200px" } : {}}
            transition={{ delay: 0.6, duration: 1 }}
          />
        </motion.div>
      </div>

      {/* Border glow */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#3b82f6]/30 to-transparent" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#3b82f6]/30 to-transparent" />
    </section>
  );
};

export default BrandBanner;
